import { Http } from '../axios-request/Axios';
import { EAxiosResponseCode, getHttpErrorMessage } from '../axios-request/IAxiosRequest';
import { getHostbaseUrl } from '@core/tools';
const hostUrl = getHostbaseUrl();

export async function querySignAuthInfo() {
  let result = {} as ISignAuthInfo;
  
  try {
    const { code, context, message } = await Http.get<ISignAuthInfo>(
      `${hostUrl}/contract/sign-auth/info`, {},
    );

    if (code === EAxiosResponseCode.Succeed) {
      result = context || {} as ISignAuthInfo;
    } else if (message) {
      throw new Error(message);
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return result;
}

export async function querySignAuthUrl(type: number, entrance: number) {
  let result = '';
  
  try {
    const { code, context, message } = await Http.get<string>(
      `${hostUrl}/contract/sign-auth/url`, {
        type,
        entrance, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      result = context;
    } else if (message) {
      throw new Error(message);
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return result;
}

export async function querySignAuthDetail() {
  let result = {} as ISignAuthDetail;
  
  try {
    const { code, context, message } = await Http.get<ISignAuthDetail>(
      `${hostUrl}/contract/sign-auth/detail`, {},
    );

    if (code === EAxiosResponseCode.Succeed) {
      result = context || {} as ISignAuthDetail;
    } else if (message) {
      throw new Error(message);
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return result;
}

export async function querySignAuthDCInfo(fddFlag: string) {
  let result = {} as ISignAuthDCInfo;
  
  try {
    const { code, context, message } = await Http.get<ISignAuthDCInfo>(
      `${hostUrl}/contract/sign-auth/dc-info`, { fddFlag },
    );

    if (code === EAxiosResponseCode.Succeed) {
      result = context || {} as ISignAuthDCInfo;
    } else if (message) {
      throw new Error(message);
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return result;
}

export interface ISignAuthInfo {
  /**  是否强制实名 0：否 1：是 */
  forceAuth: number;
  /**  实名状态 0：待实名 1:实名中 2:实名失败 3:实名完成 */
  authStatus: number;
  /**  实名失败原因*/
  failReason: string;
  /**  免验授权状态 0:未免验授权 1：免验授权中 2:免验授权失败 3:已免密授权 4:授权已到期 */
  exemptAuthStatus: number;
  /** 是否已创建手绘签名0:否 1：是 */
  createSignStatus: number;
  /** 类型 0:企业 1:个人 */
  type: number;
}

export interface ISignAuthDetail {
  /** 实名详细表主键id*/
  id: number;
  /** 认证表id*/
  authId: number;
  /** 个人/企业在法大大实名后生成的唯一标识*/
  fddFlag: string;
  /** 企业/个人名称 */
  name: string;
  /** 企业编码 */
  companyCode: string;
  /** 营业执照预览地址 */
  businessLicenseUrl: string;
  /** 证件类型 id_card: 身份证 hk_mac_rp：港澳居民居住证 taiwan_rp：台湾居民居住证 foreign_prc：外国人永久居留身份证 passport: 护照 hk_macao: 港澳居民来往内地通行证 taiwan: 台湾居民来往大陆通行证 */
  certType: string;
  /** 证件号码 */
  certNo: string;
  /** 手机号/邮箱 */
  phone: string;
  /** 企业认证方式： legal_rep: 法定代表人身份认证 deputy_auth: 法定代表人授权认证 payment: 企业对公账户认证 offline: 纸质材料审核认证 */
  companyAuthType: string;
  /** 个人认证方式用户实名认证时所选择的认证方式： mobile: 实名手机号认证 face: 人脸识别认证 bank: 个人银行卡认证 offline: 人工审核认证 */
  personalAuthType: string;
  /** 实名审核通过时间 */
  authTime: string;
  /** 免验详情 */
  freeSignDetailVO: IfreeSignDetailVO[];
}

export interface IfreeSignDetailVO {
  /** 印章id */
  sealId: number;
  /** 免验签授权的印章/签名名称 */
  sealName: number;
  /** 免验签授权的印章/签名类型 official_seal：公章 ，standard：， handwriting：手绘签名  */
  sealType: number;
  /** 印章/签名预览地址 */
  sealPicUrl: string;
  /** 免验签授权到期时间,直接获取,格式为yyyy-MM-dd HH:mm:ss */
  freeSignExpireTime: string;
}

export interface ISignAuthDCInfo {
  /** 预览地址 */
  certImg: string;
  /** 证书状态 valid:生效中:invalid:已失效 */
  status: string;
}

export enum ESealType {
  /** 公章 */
  OFFICIAL_SEAL = 'official_seal',
  /** 默认签名 */
  STANDARD = 'standard',
  /** 手绘签名 */
  HANDWRITING = 'handwriting',
}

export const sealTypeLabel = {
  [ESealType.OFFICIAL_SEAL]: '公章',
  [ESealType.STANDARD]: '默认签名',
  [ESealType.HANDWRITING]: '手绘签名',
};
